import WorkspaceThemeSelector from './WorkspaceThemeSelector';

export default WorkspaceThemeSelector;
